export type LegendSurveyPosition = readonly [lon: number, lat: number];

export interface LegendSurveySectionLineString {
  readonly type: 'LineString';
  readonly coordinates: readonly LegendSurveyPosition[];
}

export const LEGEND_SURVEY_GEO_BBOX: readonly [
  west: number,
  south: number,
  east: number,
  north: number,
] = [-2.741707, 52.952205, -1.97749, 53.375591];


export const LEGEND_SURVEY_LAYER_SPATIAL_REFERENCE = {
  wkid: 3857,
} as const;

export const LEGEND_SURVEY_SECTION_LINESTRINGS: readonly LegendSurveySectionLineString[] = [
  {
    type: 'LineString',
    coordinates: [
      [-2.251783, 53.118266],
      [-2.251765, 53.117588],
      [-2.251752, 53.11722],
      [-2.251756, 53.116639],
      [-2.251776, 53.11607],
      [-2.251798, 53.115549],
      [-2.251817, 53.11524],
      [-2.251827, 53.115127],
      [-2.251831, 53.115074],
      [-2.251942, 53.114653],
      [-2.252043, 53.114338],
      [-2.252158, 53.114025],
      [-2.252346, 53.113589],
      [-2.252381, 53.11351],
      [-2.252412, 53.113439],
      [-2.25246, 53.113331],
      [-2.252487, 53.113273],
      [-2.252541, 53.113152],
      [-2.252782, 53.112632],
      [-2.252901, 53.112347],
      [-2.252991, 53.112046],
    ],
  },
  {
    type: 'LineString',
    coordinates: [
      [-2.254451, 53.132965],
      [-2.254501, 53.132519],
      [-2.254656, 53.131098],
      [-2.254676, 53.130744],
      [-2.254683, 53.130409],
      [-2.254666, 53.129926],
      [-2.254639, 53.12958],
      [-2.254575, 53.12913],
      [-2.254534, 53.128873],
      [-2.254459, 53.128528],
      [-2.254378, 53.128189],
      [-2.254309, 53.127893],
      [-2.254095, 53.126939],
      [-2.254063, 53.126746],
      [-2.25406, 53.126491],
      [-2.254075, 53.126262],
      [-2.254081, 53.126186],
      [-2.254106, 53.125857],
      [-2.254131, 53.125403],
      [-2.254124, 53.125202],
      [-2.254089, 53.124972],
      [-2.254035, 53.124742],
      [-2.253968, 53.124531],
      [-2.253855, 53.124309],
      [-2.253565, 53.123776],
      [-2.253071, 53.12292],
      [-2.252933, 53.122646],
      [-2.2529, 53.122566],
      [-2.252833, 53.12241],
      [-2.252806, 53.122346],
      [-2.252678, 53.122008],
      [-2.252464, 53.121388],
      [-2.252242, 53.120754],
      [-2.252145, 53.120428],
      [-2.252027, 53.119911],
      [-2.25191, 53.119435],
      [-2.251829, 53.119062],
      [-2.251805, 53.11891],
      [-2.251786, 53.118373],
      [-2.251783, 53.118266],
    ],
  },
  {
    type: 'LineString',
    coordinates: [
      [-2.25001, 53.140795],
      [-2.250126, 53.140702],
      [-2.250462, 53.140417],
      [-2.250718, 53.140191],
      [-2.251035, 53.139947],
      [-2.251356, 53.139687],
      [-2.251611, 53.139463],
      [-2.251853, 53.139246],
      [-2.252031, 53.139074],
      [-2.252245, 53.138862],
      [-2.252444, 53.138652],
      [-2.252514, 53.138575],
      [-2.252774, 53.138285],
      [-2.253035, 53.137956],
      [-2.253247, 53.137668],
      [-2.253372, 53.137484],
      [-2.253486, 53.137297],
      [-2.253656, 53.136979],
      [-2.253692, 53.136902],
      [-2.253699, 53.136884],
      [-2.253801, 53.1366],
      [-2.25385, 53.136486],
      [-2.253886, 53.136408],
      [-2.253984, 53.136124],
      [-2.254056, 53.135896],
      [-2.254106, 53.13572],
      [-2.254145, 53.135533],
      [-2.25418, 53.135328],
      [-2.254204, 53.135124],
      [-2.254242, 53.134794],
      [-2.254288, 53.134399],
      [-2.254324, 53.134088],
      [-2.254381, 53.133577],
      [-2.254436, 53.133105],
      [-2.254451, 53.132965],
    ],
  },
  {
    type: 'LineString',
    coordinates: [
      [-2.2323, 53.154286],
      [-2.232305, 53.154234],
      [-2.23231, 53.154199],
      [-2.232324, 53.154109],
      [-2.232355, 53.154004],
      [-2.232388, 53.153874],
      [-2.232456, 53.153642],
      [-2.2325, 53.153493],
      [-2.232565, 53.153292],
      [-2.232584, 53.153222],
      [-2.2326, 53.153163],
      [-2.23264, 53.153045],
      [-2.232674, 53.152937],
      [-2.2327, 53.15285],
      [-2.232718, 53.1528],
      [-2.232745, 53.152731],
      [-2.232751, 53.152713],
      [-2.232814, 53.152556],
      [-2.232964, 53.152187],
      [-2.233082, 53.151899],
      [-2.233137, 53.151762],
      [-2.233181, 53.151658],
      [-2.233196, 53.15163],
      [-2.233228, 53.15157],
      [-2.233253, 53.151512],
      [-2.233269, 53.151478],
      [-2.233294, 53.151436],
      [-2.233369, 53.151339],
      [-2.233452, 53.151233],
      [-2.233528, 53.151136],
      [-2.233611, 53.151028],
      [-2.233703, 53.150929],
      [-2.233784, 53.150835],
      [-2.234054, 53.150531],
      [-2.234255, 53.150313],
      [-2.234329, 53.150232],
      [-2.234407, 53.150159],
      [-2.234489, 53.150089],
      [-2.234564, 53.150032],
      [-2.234637, 53.149975],
      [-2.234771, 53.149895],
      [-2.234941, 53.149795],
      [-2.235116, 53.149689],
      [-2.235286, 53.149594],
      [-2.235603, 53.149435],
      [-2.235803, 53.149344],
      [-2.235947, 53.14928],
      [-2.236022, 53.14925],
      [-2.236094, 53.149221],
      [-2.236252, 53.149146],
      [-2.236401, 53.149069],
      [-2.236571, 53.148984],
      [-2.236704, 53.14891],
      [-2.236848, 53.148826],
      [-2.236997, 53.148732],
      [-2.237146, 53.14864],
      [-2.237254, 53.14857],
      [-2.237371, 53.148487],
      [-2.237489, 53.148391],
      [-2.238047, 53.147948],
      [-2.238177, 53.147842],
      [-2.238308, 53.147745],
      [-2.238416, 53.147669],
      [-2.23855, 53.147574],
      [-2.238689, 53.147488],
      [-2.238781, 53.147429],
      [-2.238892, 53.147367],
      [-2.239054, 53.147278],
      [-2.23951, 53.147013],
      [-2.239525, 53.147004],
      [-2.239677, 53.146936],
      [-2.239737, 53.146911],
      [-2.239794, 53.146883],
      [-2.239881, 53.146834],
      [-2.239972, 53.146775],
      [-2.240166, 53.146651],
      [-2.24069, 53.146271],
      [-2.241179, 53.1459],
      [-2.241212, 53.145879],
      [-2.241519, 53.145651],
      [-2.241787, 53.145458],
      [-2.242027, 53.145297],
      [-2.242517, 53.144979],
      [-2.24286, 53.144766],
      [-2.24313, 53.1446],
      [-2.243267, 53.144519],
      [-2.243401, 53.144435],
      [-2.243469, 53.144388],
      [-2.243536, 53.14434],
      [-2.243607, 53.144294],
      [-2.243781, 53.144197],
      [-2.243858, 53.144152],
      [-2.243937, 53.144108],
      [-2.244018, 53.144068],
      [-2.24411, 53.144025],
      [-2.244213, 53.143984],
      [-2.244324, 53.143944],
      [-2.244637, 53.143797],
      [-2.244951, 53.143654],
      [-2.245114, 53.143578],
      [-2.245613, 53.143343],
      [-2.245746, 53.143284],
      [-2.246156, 53.143095],
      [-2.246302, 53.143029],
      [-2.24689, 53.142752],
      [-2.247328, 53.14255],
      [-2.247583, 53.142427],
      [-2.247901, 53.142269],
      [-2.248085, 53.142173],
      [-2.248237, 53.142087],
      [-2.248559, 53.141899],
      [-2.248778, 53.141764],
      [-2.24883, 53.141733],
      [-2.248872, 53.141708],
      [-2.248964, 53.141643],
      [-2.249139, 53.141522],
      [-2.249399, 53.141327],
      [-2.249565, 53.141195],
      [-2.24977, 53.141023],
      [-2.249978, 53.140839],
      [-2.25003, 53.140796],
    ],
  },
  {
    type: 'LineString',
    coordinates: [
      [-2.229074, 53.164473],
      [-2.229428, 53.164395],
      [-2.229569, 53.164368],
      [-2.229697, 53.164343],
      [-2.229817, 53.164319],
      [-2.229938, 53.164299],
      [-2.230069, 53.164282],
      [-2.230208, 53.164263],
      [-2.230329, 53.164254],
    ],
  },
  {
    type: 'LineString',
    coordinates: [
      [-2.218774, 53.166925],
      [-2.218831, 53.166884],
      [-2.218918, 53.166831],
      [-2.219002, 53.166786],
      [-2.21923, 53.166666],
      [-2.219631, 53.166456],
      [-2.21997, 53.166275],
      [-2.219991, 53.166263],
      [-2.220106, 53.166204],
      [-2.220143, 53.166184],
      [-2.220184, 53.166161],
      [-2.220218, 53.166143],
      [-2.220348, 53.166061],
      [-2.220447, 53.165992],
      [-2.220596, 53.165882],
      [-2.220785, 53.16572],
      [-2.220981, 53.165539],
      [-2.221189, 53.165323],
      [-2.221382, 53.165128],
      [-2.22145, 53.165064],
      [-2.221657, 53.164911],
    ],
  },
  {
    type: 'LineString',
    coordinates: [
      [-2.218235, 53.167451],
      [-2.218287, 53.167358],
      [-2.218383, 53.167273],
      [-2.218646, 53.167057],
      [-2.218738, 53.166963],
      [-2.218774, 53.166925],
    ],
  },
  {
    type: 'LineString',
    coordinates: [
      [-2.218037, 53.167373],
      [-2.218064, 53.167362],
      [-2.218128, 53.167327],
      [-2.218198, 53.167278],
      [-2.218319, 53.16719],
      [-2.218417, 53.167109],
      [-2.218496, 53.167052],
      [-2.218589, 53.166993],
      [-2.218774, 53.166925],
    ],
  },
];

export function buildLegendSectionLineString(index: number): {
  readonly type: 'LineString';
  readonly coordinates: readonly LegendSurveyPosition[];
} {
  const template =
    LEGEND_SURVEY_SECTION_LINESTRINGS[
      index % LEGEND_SURVEY_SECTION_LINESTRINGS.length
    ];
  return {
    type: 'LineString',
    coordinates: template
      ? template.coordinates.map(([lon, lat]): LegendSurveyPosition => [lon, lat])
      : [],
  };
}
